// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 939) return "css/core.939.c39bc71986fa8e97ecba.main.css";
	if (chunkId === 179) return "css/core.main.c298153eee7d53a9b271.main.css";
	// return url for filenames based on template
	return "css/core.chunk." + {"172":"bot","405":"cfd","856":"cashier"}[chunkId] + "." + {"172":"712a15d625db629d01c8","405":"679f5771fac985b270c9","856":"23f99f294a27e1569d21"}[chunkId] + ".css";
};